import {
	Component,
  OnInit,
  OnDestroy
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment }            from '../../environments/environment';
import { DataService }            from '../services/data.service';
import { EventService }           from '../services/event.service';
import { SpinnerService }         from '../utilities/spinner/spinner.service';

@Component({
  selector: 'app-vehicle',
  templateUrl: './vehicle.component.html',
  styleUrls: ['./vehicle.component.css']
})
export class VehicleComponent implements OnInit, OnDestroy {
	nTotoalStep: number;
	nCurrentStep: number;

	strSlug: string;
	strHelpIcon: string;
	strLiveHelpIcon: string;
	strBackendApi: string;
	bIsHelpStatus: boolean;
	bIsLiveHelpStatus: boolean;
	bIsPageLoading: boolean;

	sub: any;

	vehicleData: Object;
	PEMISSIONDENIED = 'Permission denied.';
	bCheckPermission: boolean = false;

	constructor(
		private route: ActivatedRoute,
		private _dataService: DataService,
		private _eventService: EventService,
		private router: Router,
		private _spinner: SpinnerService
	) {
		this.strBackendApi = environment['API'];
		this.nTotoalStep = 0;
		this.nCurrentStep = 0;
	}

	initVehicleData(data: any) {
		console.log(data);
		this.nTotoalStep = data.steps.totalStep;
		this.nCurrentStep = data.steps.currentStep;
		this.strLiveHelpIcon = this.strBackendApi + data.liveHelp.icon;
		this.strHelpIcon = this.strBackendApi + data.help.icon;
		let logoIcon = this.strBackendApi + data.ui.logo;

		if(data.liveHelp.on === 1) {
			this.bIsLiveHelpStatus = true;
		} else {
			this.bIsLiveHelpStatus = false;
		}

		if(data.help.on === 1) {
			this.bIsHelpStatus = true;
		} else {
			this.bIsHelpStatus = false;
		}

		this._eventService.emit('load_topbar_data', {
			helpIcon: this.strHelpIcon,
			helpStatus: this.bIsHelpStatus,
			liveHelpIcon: this.strLiveHelpIcon,
			liveHelpStatus: this.bIsLiveHelpStatus,
			logoIcon: logoIcon,
			helpLink: data.help.link
		});
		this.bIsPageLoading = true;
		this._spinner.stop();
	}

	ngOnInit() {
		this.bIsPageLoading = false;
		this._spinner.start();
		this.sub = this.route.params.subscribe(params=> {
			this.strSlug = params['slugId'];
			this._spinner.start();
			let postData = {
				code: 200,
				data: {
					slug: this.strSlug
				}
			};

			this._dataService.post('v1/data/getclaim', postData)
				.subscribe((res: any) => {
					this.initVehicleData(res.data);
					this.vehicleData = res.data;
					this.redirectWithPermissionIssue();
					this.bCheckPermission = true;
					this._spinner.stop();
				}, (error: any) => console.error('Unable to fetch brands', error));

		});
	}

	ngOnDestroy() {
		this.sub.unsubscribe();
	}

	redirectWithPermissionIssue() {
		if(this.vehicleData && (this.vehicleData as any).message === this.PEMISSIONDENIED) {
			alert((this.vehicleData as any).message);
			this.router.navigate(['/']);
		}
	}

	//from vehicle to damage
	next() {
		this.router.navigate(['/damage', this.strSlug]);
	}

}



// WEBPACK FOOTER //
// /home/rubylover/Work/new_vin_photo/site/web/src/app/vehicle/vehicle.component.ts